import { PHONE_REGEX_PATTERN } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const validateConstant = {
  MIN: 8,
}

export const PasswordForm = Yup.object().shape({
  currentPassword: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.CURRENT_PASSWORD')}</Translation>)
    .min(
      validateConstant.MIN,
      <Translation>{(t) => t('VALIDATE.MIN_PASSWORD', { number: validateConstant.MIN })}</Translation>
    ),
  newPassword: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.NEW_REQUIRED_PASSWORD')}</Translation>)
    .min(
      validateConstant.MIN,
      <Translation>{(t) => t('VALIDATE.MIN_PASSWORD', { number: validateConstant.MIN })}</Translation>
    ),
  confirmNewPassword: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.CONFIRM_PASSWORD_REQUIRED')}</Translation>)
    .min(
      validateConstant.MIN,
      <Translation>{(t) => t('VALIDATE.MIN_PASSWORD', { number: validateConstant.MIN })}</Translation>
    )
    .oneOf([Yup.ref('newPassword')], <Translation>{(t) => t('VALIDATE.MATCH_PASSWORD')}</Translation>),
})

export const OTPForm = Yup.object().shape({
  otp: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.OTP')}</Translation>),
})

export const ProfileForm = Yup.object().shape({
  name: Yup.string()
    .trim()
    .max(255)
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>),

  email: Yup.string()
    .email(<Translation>{(t) => t('VALIDATE.VALID_EMAIL')}</Translation>)
    .max(255)
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_EMAIL')}</Translation>),

  phone: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PHONE')}</Translation>)
    .matches(PHONE_REGEX_PATTERN, { message: <Translation>{(t) => t('VALIDATE.VALID_PHONE')}</Translation> }),
})
